import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CounsellorRegisterVM, AccountStatus } from '../models';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class SignupService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  public validateEmailAddress(emailAddress: string): Observable<boolean> {
    return this.http.post('/api/signup/validateemail',
      JSON.stringify(emailAddress),
      this.getHttpOptions(false)).pipe(
      map(resp => !!resp));
  }

  public signup(vm: CounsellorRegisterVM): Observable<string> {
    return this.http.post('/api/signup/register', vm, this.getHttpOptions(false)).pipe(
      map(resp => resp as string));
  }

  public resendVerifyAccount(token: string): Observable<boolean> {
    return this.http.post('/api/signup/resend', JSON.stringify(token), this.getHttpOptions(false)).pipe(
      map(resp => resp as boolean));
  }

  public verifyAccount(token: string): Observable<AccountStatus> {
    return this.http.post('/api/signup/verifyaccount', JSON.stringify(token), this.getHttpOptions(false)).pipe(
      map(resp => resp as AccountStatus));
  }

  errorHandler(error: any): any {
    console.log(error)
    return error;
  }

}
